var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import React, { useCallback, useState, useEffect, useMemo } from 'react';
import MenuContainer from './MenuContainer';
import getMoreSubCategoriesQuery from './GetMoreSubcategoriesQuery.gql';
import { matchPath, withRouter } from 'react-router';
import { withApollo } from 'react-apollo';
const RecursiveTree = (_a) => {
    var { children, category, initialOpenMatchingCategories } = _a, rest = __rest(_a, ["children", "category", "initialOpenMatchingCategories"]);
    const [hasFetchedMore, setHasFetchedMore] = useState(false);
    const [subcategories, setSubcategories] = useState(category.subcategories || []);
    const { client, location } = rest;
    useEffect(() => {
        if (category.subcategories && category.subcategories !== subcategories) {
            setSubcategories(category.subcategories);
        }
    }, [category, subcategories]);
    const fetchMoreSubcategories = useCallback(() => {
        // Every second tier, fetch ahead 2 more tiers
        if (category.hasSubcategories &&
            category.level % 2 !== 0 &&
            !hasFetchedMore) {
            setHasFetchedMore(true);
            return client
                .query({
                query: getMoreSubCategoriesQuery,
                variables: { id: category.id }
            })
                .then(queryResult => {
                const { data: { category: { subcategories: fetchedCategories } } } = queryResult;
                setSubcategories(fetchedCategories);
            });
        }
    }, [category, hasFetchedMore, client]);
    const renderRecursive = useCallback((props) => {
        if (!category.hasSubcategories || !props.isActiveCategory(category))
            return null;
        return subcategories.map(subcat => (React.createElement(RecursiveTree, Object.assign({ key: subcat.id, category: subcat, initialOpenMatchingCategories: initialOpenMatchingCategories }, rest), children)));
    }, [category, subcategories, initialOpenMatchingCategories, children]);
    const initialActiveCategories = useMemo(() => {
        if (initialOpenMatchingCategories) {
            const params = {
                path: category.primaryRoute.path,
                strict: false,
                exact: false
            };
            const match = matchPath(location.pathname, params);
            if (match) {
                return [category];
            }
        }
        return [];
    }, [location, initialOpenMatchingCategories, category]);
    useEffect(() => {
        if (initialActiveCategories && !hasFetchedMore && !category.subcategories) {
            fetchMoreSubcategories();
        }
    }, [
        initialActiveCategories,
        hasFetchedMore,
        category,
        fetchMoreSubcategories
    ]);
    return (React.createElement(MenuContainer, { allowMultipleActive: true, initialActiveCategories: initialActiveCategories }, menuProps => children({
        fetchMore: fetchMoreSubcategories,
        menuContainerProps: menuProps,
        subcategories,
        hasSubcategories: category.hasSubcategories,
        category,
        renderSubnav: renderRecursive(menuProps),
        level: category.level
    })));
};
export default withApollo(withRouter(RecursiveTree));
//# sourceMappingURL=RecursiveTree.js.map